import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import {
  Box as FiltersBox,
  Controls as FiltersControls,
} from '@/components/Shops/ShopsFilters/ShopsFiltersLayout.styles';

const CONTENT_MAX_WIDTH = 1280;

export const ShopsContentWrap = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.palette.primary.background};
`;

export const ShopsContentInner = styled.div`
  width: 100%;
  max-width: ${CONTENT_MAX_WIDTH}px;
  margin: 0 auto;
  min-width: 0;
  box-sizing: border-box;
  padding: 0 0 50px;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 0 30px 50px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 15px 24px;
  }
`;

export const PageTitle = styled(Typography.Title).attrs({ as: 'h1' })`
  margin: 0 0 16px 0;
  padding-top: 16px;
  font-size: 24px;
  line-height: 1.25;
  color: ${({ theme }) => theme.palette.primary.labels};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 20px;
    padding-top: 24px;
    font-size: 28px;
  }
`;

export const TopFiltersRow = styled.div`
  padding: 0 0 15px;
  display: flex;
  gap: 10px;
  align-items: stretch;

  & > :first-child {
    flex: 1 1 auto;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 0 25px;
    gap: 0;
  }
`;

export { FiltersBox, FiltersControls };
